var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.426 10.853a.491.491 0 01-.348-.144L.144 6.775a.493.493 0 010-.7L4.078 2.14a.495.495 0 01.7.7L1.191 6.426l3.587 3.587a.492.492 0 01-.348.84z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.918 6.919H.492a.492.492 0 010-.984h14.426a.492.492 0 010 .984zM14.918 16.099H.492a.492.492 0 010-.984h14.426a.492.492 0 010 .984z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.918 16.099a.492.492 0 010-.984 4.1 4.1 0 000-8.2.492.492 0 010-.984 5.082 5.082 0 010 10.164z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/Return.3ae01361c0aaef51c65335c51d031387.svg";
export { ForwardRef as ReactComponent };